export const pushDataLayer = nextDataLayer => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(nextDataLayer);
};

export const pushGTMEvent = (type, dataLayer) =>
  pushDataLayer({ ...dataLayer, event: type });

export default pushGTMEvent;
